"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _broadcastSourceHelper = require("./broadcastSourceHelper");
Object.keys(_broadcastSourceHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _broadcastSourceHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _broadcastSourceHelper[key];
    }
  });
});